// Tipovi i konstante
import {
  ResidualValue,
  ResidualValueEditFormValues,
  ResidualValueRow,
  ResidualValueTableEditFormValues,
  ResidualValueTable,
} from "./types";

// Transformacije
import {
  transformResidualValue,
  transformResidualValueOnCreate,
  transformResidualValueOnUpdate,
  transformResidualValueRow,
  transformResidualValueTable,
  transformResidualValueTableOnUpdate,
} from "./transformations";

// API servisi
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

// Tipovi i konstante vezani za paginaciju
import { Pagination } from "services/search";
import { DataWithPagination } from "services/api/types";

/*---------------------------------------------------------------------------------------
 CALCULATION RESIDUAL VALUE SEARCH
-----------------------------------------------------------------------------------------*/

export const getResidualValuesAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<ResidualValueRow>> => {
  let path = `/v1/expenses/residual-value?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformResidualValueRow);
};

/*---------------------------------------------------------------------------------------
    CALCULATION RESIDUAL VALUE - BY ID
-----------------------------------------------------------------------------------------*/
export const getResidualValueAPI = async (
  id: string
): Promise<ResidualValue> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/residual-value/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformResidualValue(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION RESIDUAL VALUE - CREATE
-----------------------------------------------------------------------------------------*/
export const createResidualValueAPI = async (
  formValues: ResidualValueEditFormValues
): Promise<ResidualValue> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/residual-value/",
      method: "POST",
      body: transformResidualValueOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Tablica ostatka vrijednosti je uspješno kreiran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformResidualValue(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION RESIDUAL VALUE - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateResidualValueAPI = async (
  id: string,
  formValues: ResidualValueEditFormValues
): Promise<ResidualValue> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/residual-value/${id}`,
      method: "PUT",
      body: transformResidualValueOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Tablica ostatka vrijednosti je uspješno ažurirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformResidualValue(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - RESIDUAL VALUE - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteResidualValueAPI = async (
  id: string
): Promise<ResidualValue> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/residual-value/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Tablica ostatka vrijednosti je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformResidualValue(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION RESIDUAL VALUE - TABLE
-----------------------------------------------------------------------------------------*/

export const getResidualValueTableAPI = async (
  id: string
): Promise<ResidualValueTable> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/residual-value/${id}/table`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformResidualValueTable(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION RESIDUAL VALUE TABLE - UPDATE
-----------------------------------------------------------------------------------------*/

export const updateResidualValueTableAPI = async (
  residualValueExpenseId: string,
  formValues: ResidualValueTableEditFormValues
): Promise<ResidualValueTable> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/residual-value/${residualValueExpenseId}/table/`,
      method: "PUT",
      body: transformResidualValueTableOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Tablica ostatka vrijednosti je uspješno ažurirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformResidualValueTable(response.data);
};
